export type SupportDescriptionItem = {
  text?: string;
  richText?: string;
};

export type SupportDescriptionMap = Record<string, SupportDescriptionItem>;

export const mapSupportDescription = (data?: SupportDescriptionMap) => {
  if (!data) return null;
  let richTextValue = "";
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.entries(data).forEach(([key, value]) => {
    if (value.richText) {
      richTextValue += value.richText;
    } else if (value.text) {
      richTextValue += `<p className="mb-[8px]">${value.text}</p>`;
    }
  });
  return richTextValue;
};
